{
  "hash": "g1dcec74d9",
  "version": "1.0.0",
  "buildNumber": "202607060648"
}